// Flow types automatically removed

import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { MatchmakerContainer } from '../matchmaker/MatchmakerContainer.jsx';
import '../matchmaker/matchmaker.scss';
const locale = serverVars.get('locale');
initializeDBL().then(() => {
    const matchMakerNode = createElement(MatchmakerContainer);
    const containerElement = document.getElementById('matchmakerRoot');

    if (containerElement) {
        const root = createRoot(containerElement);
        root.render(
            createElement(
                IntlProvider,
                {
                    locale,
                    disableTranslations: true,
                },
                matchMakerNode
            ),
            document.getElementById('matchmakerRoot')
        );
    }
});
